import { FC } from "react"
import { useTranslation } from "react-i18next"
import { SORT_OPTIONS } from "@/hooks/useInventorySortSearch"
import styles from "./SortSelect.module.scss"
import { ISortSelectProps } from "./types"

export const SortSelect: FC<ISortSelectProps> = ({ value, onChange }) => {
  const { t } = useTranslation("inventory")
  return (
    <select
      className={styles.SortSelect}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      {SORT_OPTIONS.map((option) => (
        <option key={option.key} value={option.key}>
          {t(option.labelKey)}
        </option>
      ))}
    </select>
  )
}
